import React, { Component } from 'react';
import {
    firstAvailableStorageDestination,
    installableStorageIndexes,
    removableRooms,
    renovationDestinations,
    sellableRoomsByRenovation
} from '../../../Common/StationUtilities';
import {
    CLEAR_ACTION_SELECTION_EVENT,
} from '../../../../Dashboard/ActionWindows/CurrentAction';

export default class RenovationController extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
        this.selectedStorageGridIndex = null;
        this.selectedStationGridIndex = null;

        this.destinations = [];
        this.sellable = [];
        this.removable = [];
        this.installable = [];
        this.storageDestination = null;
    }

    componentDidMount() {
        this.step1();
        window.addEventListener(
            'hotel-interface-mounted-event', this.step1);
        window.addEventListener(
            CLEAR_ACTION_SELECTION_EVENT, this.clearSelection);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.step1();
    }

    componentWillUnmount() {
        this.clearAllHighlights();
        window.removeEventListener(
            'hotel-interface-mounted-event', this.step1);
        window.removeEventListener(
            CLEAR_ACTION_SELECTION_EVENT, this.clearSelection);
    }

    // Reset the in-controller two-step selection (Storage or
    // Station tile picked, destination still pending) and re-run
    // step1 to republish the initial highlight set. No engine
    // round-trip — the first click never sent a package; it only
    // primed the highlight callback chain. Fired by the Clear
    // button on CurrentAction.
    clearSelection = () => {
        if (this.selectedStorageGridIndex === null
                && this.selectedStationGridIndex === null) {
            return;
        }
        this.selectedStorageGridIndex = null;
        this.selectedStationGridIndex = null;
        this.clearAllHighlights();
        this.step1();
    };

    step1 = () => {
        // If a storage or station has already been picked, an
        // install/move/sell/uninstall is mid-flight. Bailing here
        // preserves the second-pass highlight set + callback that
        // onFirstStorageClick / onFirstStationClick just registered.
        // Without this guard, componentDidUpdate (fired by parent
        // re-renders or the hotel-interface-mounted-event re-bind)
        // overwrites highlightedRooms back to [removable, sellable]
        // and callback back to onFirstStationClick, so the user's
        // second click lands on an empty (un-highlighted) destination
        // slot and StationRoom.onClick silently drops it.
        if (this.selectedStorageGridIndex !== null) return;
        if (this.selectedStationGridIndex !== null) return;

        this.selectedStorageGridIndex = null;
        this.selectedStationGridIndex = null;
        const gamePlayerData = this.props.app.game.seatedController.gamePlayerData;

        this.sellable = sellableRoomsByRenovation(gamePlayerData);
        this.removable = removableRooms(gamePlayerData);

        this.destinations = renovationDestinations(gamePlayerData);
        this.storageDestination = firstAvailableStorageDestination(this.props.gamePlayerData);

        let rooms = [ ...this.removable, ...this.sellable ];
        window.dispatchEvent(
            new CustomEvent('highlight-rooms-event',
                {
                    detail: {
                        highlightedRooms: rooms,
                        callback: this.onFirstStationClick
                    }
                }));

        this.installable = installableStorageIndexes(gamePlayerData);
        window.dispatchEvent(
            new CustomEvent('highlight-storage-event',
                {
                    detail: {
                        indexes: this.installable,
                        callback: this.onFirstStorageClick
                    }
                }));
    }

    onFirstStationClick = (stationIndex) => {
        console.log('onFirstStationClick', stationIndex);
        this.clearAllHighlights();
        this.selectedStationGridIndex = stationIndex;

        let rooms = [ ...this.destinations, ...this.sellable ];
        window.dispatchEvent(
            new CustomEvent('highlight-rooms-event',
                {
                    detail: {
                        highlightedRooms: rooms,
                        callback: this.onSecondStationClick
                    }
                }));
        if (this.storageDestination !== null) {
            window.dispatchEvent(
                new CustomEvent('highlight-storage-event',
                    {
                        detail: {
                            indexes: [this.storageDestination],
                            callback: this.uninstallToStorage
                        }
                    }));
        }
    };

    onFirstStorageClick = (stationIndex) => {
        console.log('onFirstStorageClick', stationIndex);
        this.selectedStorageGridIndex = stationIndex;
        window.dispatchEvent(
            new CustomEvent('highlight-rooms-event',
                {
                    detail: {
                        highlightedRooms: this.destinations,
                        callback: this.installFromStorage
                    }
                }));
    };

    installFromStorage = (stationGridIndex) => {
        this.api.installFromStorage(
            stationGridIndex,
            this.selectedStorageGridIndex);
        this.clearAllHighlights();
    }

    uninstallToStorage = () => {
        this.api.uninstallToStorage(this.selectedStationGridIndex);
        this.clearAllHighlights();
    }

    onSecondStationClick = (stationIndex) => {
        if (this.selectedStationGridIndex === stationIndex) {
            this.api.renovationSell(stationIndex);

        } else {
            this.api.renovationMove(
                this.selectedStationGridIndex, stationIndex)
        }
        this.clearAllHighlights();
    };

    clearAllHighlights = () => {
        window.dispatchEvent(new Event('clear-storage-highlight-event'));
        window.dispatchEvent(new Event('clear-rooms-highlight-event'));
    }

    render() {
        return <></>;
    }
}
